import type { PaletteOptions } from '@mui/material/styles';

/**
 * Light theme palette - derived from contactlight.png and projectslight.png
 * Maintains the same accent colors but with light backgrounds and proper contrast
 */
export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#00d4cc', // Slightly darker cyan for better contrast on light
    light: '#22d3ee',
    dark: '#00a39a',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#7c3aed', // Electric Violet (same as dark)
    light: '#a78bfa',
    dark: '#6d28d9',
    contrastText: '#ffffff',
  },
  background: {
    default: '#F8FAFC', // Soft light gray (Slate 50)
    paper: '#FFFFFF', // Pure white for cards
  },
  text: {
    primary: '#0F172A', // Slate 900 - deep charcoal for text
    secondary: '#475569', // Slate 600 - medium gray
  },
  divider: 'rgba(15, 23, 42, 0.08)', // Subtle dark divider
  action: {
    hover: 'rgba(0, 0, 0, 0.04)',
    selected: 'rgba(139, 92, 246, 0.12)',
    hoverOpacity: 0.04,
    selectedOpacity: 0.12,
  },
  error: {
    main: '#dc2626', // Slightly darker red for light mode
  },
  warning: {
    main: '#ea580c', // Slightly darker orange
  },
  info: {
    main: '#2563eb', // Slightly darker blue
  },
  success: {
    main: '#059669', // Slightly darker green
  },
};
